<div [ngClass]="{ 'input-group-sm': small_input, 'input-group': true }">
  <input
    [(ngModel)]="vendorSearchTerm"
    type="text"
    [appAutocomplete]="'/vendors/autocomplete_vendor_by_name'"
    [include_item]="include_item"
    (autocompleteSelect)="vendorSearchOnSelect($event)"
    [placeholder]="placeholder || 'Search for vendor'"
    class="form-control"
    [data]="data"
    [disabled]="!select_only && (!!vendorId || !editable)"
    name="vendor-search"
    ngDefaultControl
  />
  <div class="input-group-append" *ngIf="!select_only">
    <button type="button" class="btn btn-primary btn-lg" [disabled]="!vendorId || !editable" (click)="clearSelectedVendor()">
      <span class="fas fa-pencil-alt"></span>
    </button>
  </div>
</div>
